import { Component, Input, OnInit } from '@angular/core';
import { AdministrationAppointment, AppointmentSummary, Lookups, MeetingAppointment, PopupModelReturn, PopupSetupModel, Staff } from '../../../AllTableClasses';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { StaffService } from '../../../Services/staff.service';
import { LookupsService } from '../../../Services/lookups.service';
import { SchedulerService } from '../../../Services/scheduler.service';
import { Subject, takeUntil } from 'rxjs';
import UserSession from '../../../Config/user-session';

@Component({
  selector: 'app-administration-popup',
  templateUrl: './administration-popup.component.html',
  styleUrls: ['./administration-popup.component.scss']
})
export class AdministrationPopupComponent implements OnInit {

  private destroy$ = new Subject<void>();

  popup: PopupSetupModel | null = null;
  popupReturn: PopupModelReturn = new PopupModelReturn();

  public submitted: boolean = false;

  @Input() Data!: AdministrationAppointment;
  public schedule: AdministrationAppointment = new AdministrationAppointment();

  public times: Array<Lookups> = new Array<Lookups>();
  public leaves: Array<Lookups> = new Array<Lookups>();
  public durations: Array<Lookups> = new Array<Lookups>();
  public appointmentTypes: Array<Lookups> = new Array<Lookups>();

  public appointments: Array<MeetingAppointment> = new Array<MeetingAppointment>();

  public staffMember!: string;
  public selectedDate!: string;

  public selectedStartTime!: string;

  public timeError: boolean = false;
  public selectedEndTime!: string;
  public selectedAppointmentType!: number;
  public selectedAppointmentName!: string;
  public duration: string = '30';
  public selectedDuration!: number;

  public staffList: Array<Staff> = new Array<Staff>();
  public selectedStaff!: number;
  public selectedCharge!: string;

  public showError: boolean = false;
  public erroMessage!: string;

  constructor(
    private popupNotificationService: PopupNotificationService,
    private staffService: StaffService,
    private lookupService: LookupsService,
    private schedulerService: SchedulerService,
  ) { }

  ngOnInit(): void {
    this.popupNotificationService.administrationNotification$.pipe(takeUntil(this.destroy$)).subscribe((popup: PopupSetupModel | null) => {
      this.popup = popup;
      if (popup?.Data != null || popup?.Data != undefined) {
        this.schedule = new AdministrationAppointment();
        this.submitted = false;
        this.schedule = popup.Data;
        this.StaffGet();
        this.TimesGet();
        this.DurationsGet();
        this.selectedStartTime = '';
        this.selectedEndTime = '';
        this.timeError = false;
        if (popup?.PopupAction == 'Leave') {
          this.LeaveTypesGet();
        }
        if (popup?.PopupAction == 'Administration') {
          this.AdministrationTypesGet();
        }
        this.selectedStartTime = this.schedule.StartTime;
        this.duration = '30';
      }
    });
  }

  StaffUpdate() {
    const selectedStaff = this.staffList.find(staff => staff.ID === this.schedule.StaffMemberID);
    if (selectedStaff) {
      this.selectedStaff = selectedStaff.ID;
    }
  }

  public TimeSelectionValidation() {
    if (this.popup?.PopupAction == 'Leave' && (this.selectedStartTime && this.selectedEndTime)) {
      let startTime = this.parseTime(this.selectedStartTime);
      let endTime = this.parseTime(this.selectedEndTime);

      // Check if both dates are available
      if (this.schedule?.DateFron && this.schedule?.DateTo) {
        const startDate = new Date(this.schedule.DateFron);
        const endDate = new Date(this.schedule.DateTo);

        // Check date range validity
        if (startDate > endDate) {
          this.timeError = true;
          this.erroMessage = 'Start date must be before end date.';
          return;
        }

        // If dates are valid, check time range
        if (startDate.getTime() === endDate.getTime() && startTime >= endTime) {
          this.timeError = true;
          this.erroMessage = 'Start time must be before end time if on the same date.';
          return;
        }
      }

      // If date and time ranges are valid
      this.timeError = false;
    } else if (this.popup?.PopupAction == 'Administration' && this.selectedStartTime) {
      this.timeError = false;
    }
  }


  parseTime(time: string): Date {
    const [hours, minutes] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0); // Set hours and minutes
    return date;
  }

  selectDuration() {
    this.selectedDuration = parseInt(this.duration);
  }

  public StaffGet() {
    this.staffService.StaffGetByBranchID(this.schedule.BranchID,(data) => {
      if (data.Success) {
        this.staffList = data.Data;
        this.StaffUpdate();
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public TimesGet() {
    this.lookupService.TimesGet((data) => {
      if (data.Success) {
        this.times = data.Data;
      }
      else {

      }
    }, (error) => { })
  };
  public DurationsGet() {
    this.lookupService.DurationsGet((data) => {
      if (data.Success) {
        this.durations = data.Data;
        this.durations = this.durations.filter(x => x.Description <= '60');
        this.duration = '30';
      }
      else {

      }
    }, (error) => { })
  }
  public AdministrationTypesGet() {
    this.lookupService.AdministrationTypesGet((data) => {
      if (data.Success) {
        this.appointmentTypes = data.Data;
      }
      else {

      }
    }, (error) => { })
  }
  public LeaveTypesGet() {
    this.lookupService.LeaveTypesGet((data) => {
      if (data.Success) {
        this.appointmentTypes = data.Data;
      }
      else {

      }
    }, (error) => { })
  }

  ButtonClick() {
    if (this.popup?.Button) {
      this.submitted = true;
      this.popupReturn.Result = this.popup.Button.Result;
      this.popupReturn.Data = this.appointments;
      this.timeError = false;
      this.popupNotificationService.ResolveAdministrationPopup(this.popupReturn);
      this.cancel();
    }
    this.submitted;
  }

  AltButtonClick() {
    if (this.popup?.AltButton) {
      this.popupReturn.Result = this.popup.AltButton.Result;
      this.timeError = false;
      this.popupNotificationService.ResolveAdministrationPopup(this.popupReturn);
      this.cancel();
    }
  }
  PopupEvent(event: string) {
    if (event === 'close') {
      this.popupReturn.Result = 'close';
      this.timeError = false;
      this.popupNotificationService.ResolveAdministrationPopup(this.popupReturn);
      this.cancel();
    }
  }

  cancel() {
    this.selectedStartTime = '';
    this.selectedEndTime = '';
    this.selectedDate = '';
    this.erroMessage = '';
    this.duration = '30';
  }

  ifFullDay() {
    this.selectedStartTime = '08:00';
    this.selectedEndTime = '18:00';
  }

  ifHalfDay() {
    // Calculate the next Saturday
    const today = new Date();
    const daysUntilSaturday = (6 - today.getDay() + 7) % 7;
    const nextSaturday = new Date(today);
    nextSaturday.setDate(today.getDate() + daysUntilSaturday);

    // Format to 'yyyy-MM-dd'
    const year = nextSaturday.getFullYear();
    const month = String(nextSaturday.getMonth() + 1).padStart(2, '0');
    const day = String(nextSaturday.getDate()).padStart(2, '0');
    this.schedule.DateFron = `${year}-${month}-${day}`;

    this.selectedStartTime = '08:00';
    this.selectedEndTime = '13:00';
  }

  public generateMeeting() {
    this.submitted = true;
    this.TimeSelectionValidation();
    if (this.timeError == true || !this.selectedStartTime || (this.popup?.PopupAction == 'Leave' && !this.selectedEndTime)) {
      //alert('Start time must be before end time.');
      this.erroMessage = 'Start time must be before end time.';
      this.timeError = true;
      return;
    }

    this.appointments = [];

    if (this.selectedAppointmentType == 37 || this.selectedAppointmentType == 38) {
      const updatedTime = this.addMinutesToTime(this.selectedStartTime, this.selectedDuration);
      const appointment: MeetingAppointment = {
        StaffMemberID: this.selectedStaff,
        StartDate: this.schedule.DateFron + ' ' + this.selectedStartTime, // Format as YYYY-MM-DD
        StartTime: '09:00', // Example value, adjust as needed
        EndDate: this.schedule.DateFron + ' ' + updatedTime, // Same day for start and end date
        EndTime: '10:00', // Example value, adjust as needed
        LocationID: 0, // Example value
        ServiceProviderID: this.selectedAppointmentType, // Example ServiceProviderID
        BranchID: this.schedule.BranchID,
        SPType: 'General' // Example type
      };

      // Push appointment into the array
      this.appointments.push(appointment);
    } else {
      const appointment: MeetingAppointment = {
        StaffMemberID: this.selectedStaff,
        StartDate: this.schedule.DateFron + ' ' + this.selectedStartTime, // Format as YYYY-MM-DD
        StartTime: this.selectedStartTime, // Example value, adjust as needed
        EndDate: this.schedule.DateTo + ' ' + this.selectedEndTime, // Same day for start and end date
        EndTime: this.selectedEndTime, // Example value, adjust as needed
        LocationID: 0, // Example value
        ServiceProviderID: this.selectedAppointmentType, // Example ServiceProviderID
        BranchID: this.schedule.BranchID,
        SPType: 'General' // Example type
      };

      // Push appointment into the array
      this.appointments.push(appointment);

    }
    this.ButtonClick()

  }

  public addMinutesToTime(timeString: string, minutesToAdd: number ) {
  // Convert "08:00" to a Date object
  const [hours, minutes] = timeString.split(':');
  const date = new Date();
  date.setHours(parseInt(hours));
  date.setMinutes(parseInt(minutes));

  // Add the desired minutes
  date.setMinutes(date.getMinutes() + minutesToAdd);

  // Format the updated time back to "HH:mm"
  const updatedHours = date.getHours().toString().padStart(2, '0');
  const updatedMinutes = date.getMinutes().toString().padStart(2, '0');

  return `${updatedHours}:${updatedMinutes}`;
  }

  ngOnDestroy(): void {
    // Emit and complete the destroy$ Subject to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
